export default {
  functionKey: "ARRONDI. INF",
  title: "ARRONDI. INF",
  group: "Calcul",
  origin: [],
  target: [],
  description: "Arrondi un nombre à l'entier inférieur",
  isStarred: false,

  generate(destination, origin, args, isArgumentCol) {
    const jsCode = `${destination} = Math.floor(${origin});`;
    const safeCode = `
      if (!isNaN(parseInt(${origin}))) {
        ${jsCode}
      } else {
        ${destination} = '';
      }`;
    return { displayCode: jsCode, safeCode };
  }
}
